import AppEvents from 'Shared/app-events';
import AsideTab from './asideTab';

export default class AsideLeft extends AsideTab
{
    constructor(options = {
        id: "aside-left",
        tabId: "aside-left__tab"
    }) {
        super(options); 

        AppEvents.on("aside.nav.show", () => this.show());
    }
}